/* eslint-disable no-shadow */
export enum AuthKeys {
  GetSession = 'auth/getSession',
  Login = 'auth/login',
  Logout = 'auth/logout'
}
